const initialState = {
  testedTexture: undefined,
};

const reducer = (state = initialState) => {
  return state;
};

export default reducer;
